import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, Typography, Button, Avatar } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StorageIcon from "@mui/icons-material/Storage";
import PageHeader from "../../components/PageHeader";

const maroon = "#500000";

const BiobankDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/researcher")}
        sx={{
          color: "text.secondary",
          textTransform: "none",
          mb: 2,
          "&:hover": { backgroundColor: "rgba(80, 0, 0, 0.06)", color: maroon },
        }}
      >
        Back to Researcher Dashboard
      </Button>

      <PageHeader title="Biobank Data" subtitle="Systems data overview" />

      <Card
        variant="outlined"
        sx={{ borderRadius: 3, textAlign: "center", py: 6 }}
      >
        <CardContent>
          <Avatar
            sx={{
              bgcolor: "rgba(47, 111, 107, 0.13)",
              color: "#2F6F6B",
              width: 64,
              height: 64,
              mx: "auto",
              mb: 2,
            }}
          >
            <StorageIcon fontSize="large" />
          </Avatar>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Biobank Dashboard Coming Soon
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 420, mx: "auto" }}
          >
            We're building out the researcher-facing view for Biobank data.
            Check back soon.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BiobankDashboard;